export function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
